// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
// Components
import GoTable from "../../../common/GoTable/GoTable";
// Services
import { get } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
import { downloadFile } from "../../../services/AwsService";
import { FORM_TABLE_HEADS } from "../../../configs/TableHeaderConstants";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
import EntityConstants from "../../../configs/EntityConstants";

const initialFilter = { sort: "id", order: "asc", max: 10, offset: 0, search: "" };


const Forms = () => {
    const spinService = SpinService();
    const [filter, setFilter] = useState(initialFilter);
    const [forms, setForms] = useState({
        entries: [],
        total_count: 0
    });

    const getForms = async () => {
        spinService.on();
        const response = await get(EntityConstants.FORMS, `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${filter.offset + 1}&search=${filter.search}`);
        const data = await response.json();
        setForms(data);
        spinService.off();
    };

    const download = async (row) => {
        downloadFile(`forms/${row.file_name}`);
    };

    useEffect(() => {
        getForms();
    }, [filter]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Forms
                    </Typography>

                </Stack>
                <Card>
                    <GoTable
                        tableHeads={FORM_TABLE_HEADS}
                        tableDatas={forms.entries}
                        totalCount={forms.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter(filter)}
                        onView={(row) => download(row)}
                    />
                </Card>
            </Container>
        </React.Fragment>
    )

};

export default Forms;